import React, { useState } from 'react';
import './tool-page.css';
import './CommunityPage.css';

const POSTS = [
  { id: 1, author: 'Rajan Kumar',   initials: 'RK', color: '#16A34A', tag: 'Setup Review', time: '2h ago',
    title: 'HDFCBANK bull flag — entry at breakout or on retest?',
    excerpt: 'Clean flag on the daily. Volume contracted for 5 sessions. Do I chase the breakout candle or wait for a retest?',
    replies: 14, helpful: 42 },
  { id: 2, author: 'Sneha Nair',    initials: 'SN', color: '#7C3AED', tag: 'Journal',       time: '5h ago',
    title: 'Weekly review — 3 wins, 2 losses, net +2.1R',
    excerpt: 'Two losses from forcing entries outside my pattern criteria. Sharing the journal for feedback.',
    replies: 8,  helpful: 61 },
  { id: 3, author: 'Arjun Verma',   initials: 'AV', color: '#D97706', tag: 'Question',      time: '1d ago',
    title: 'How do you handle a screener hit that gaps up the next morning?',
    excerpt: 'Alert fires at close, stock opens 3% up. Does the setup still work or skip it?',
    replies: 22, helpful: 37 },
  { id: 4, author: 'Priya Mehta',   initials: 'PM', color: '#0284C7', tag: 'Screener',      time: '2d ago',
    title: 'Built a volume-surge screener after Module 5 — sharing the config',
    excerpt: '8 stocks on Monday that moved 4%+ by Wednesday. Applied the formula from the momentum learning.',
    replies: 31, helpful: 94 },
  { id: 5, author: 'Kiran Rao',     initials: 'KR', color: '#DB2777', tag: 'Setup Review',  time: '3d ago',
    title: 'TATAMOTORS weekly breakout — still valid after today\'s candle?',
    excerpt: 'Was a nice base breakout but today closed inside the range. Does this invalidate the setup?',
    replies: 9,  helpful: 28 },
];

const TOPICS = [
  { label: 'Setup Reviews', count: 347 },
  { label: 'Trade Journals', count: 218 },
  { label: 'Screener Help', count: 189 },
  { label: 'Learning Questions', count: 142 },
  { label: 'Market Discussion', count: 98 },
];

const LEADERS = [
  { rank: 1, initials: 'AV', color: '#D97706', name: 'Arjun Verma',  pts: 420 },
  { rank: 2, initials: 'PM', color: '#0284C7', name: 'Priya Mehta',  pts: 388 },
  { rank: 3, initials: 'SN', color: '#7C3AED', name: 'Sneha Nair',   pts: 312 },
  { rank: 4, initials: 'RK', color: '#16A34A', name: 'Rajan Kumar',  pts: 274 },
  { rank: 5, initials: 'KR', color: '#DB2777', name: 'Kiran Rao',    pts: 201 },
];

const TAG_COLORS: Record<string, string> = {
  'Setup Review': 'pill-new',
  'Journal':      'pill-free',
  'Question':     'pill-pro',
  'Screener':     'pill-live',
};

const FILTERS = ['All', 'Setup Review', 'Journal', 'Question', 'Screener'];

const CommunityPage: React.FC = () => {
  const [activeFilter, setActiveFilter] = useState('All');

  const visible = activeFilter === 'All'
    ? POSTS
    : POSTS.filter((p) => p.tag === activeFilter);

  return (
    <div className="tool-page">
      <div className="tool-header">
        <div className="tool-header-left">
          <p className="tool-eyebrow">Community</p>
          <h1 className="tool-title">Forum</h1>
          <p className="tool-subtitle">Ask questions, share setups, review trades with fellow members.</p>
        </div>
        <button className="new-post-btn">+ New Post</button>
      </div>

      <div className="tool-stats">
        <div className="stat-chip"><div><div className="stat-chip-val">2,400+</div><div className="stat-chip-label">Members</div></div></div>
        <div className="stat-chip"><div><div className="stat-chip-val">994</div><div className="stat-chip-label">Posts</div></div></div>
        <div className="stat-chip"><div><div className="stat-chip-val">84</div><div className="stat-chip-label">Active Today</div></div></div>
      </div>

      <div className="forum-layout">
        {/* Post feed */}
        <div>
          <div className="tool-toolbar">
            {FILTERS.map((f) => (
              <button key={f} className={`tool-filter-btn ${activeFilter === f ? 'active' : ''}`} onClick={() => setActiveFilter(f)}>{f}</button>
            ))}
          </div>

          <div className="post-list">
            {visible.map((p) => (
              <div key={p.id} className="t-card post-card">
                <div className="post-avatar" style={{ background: p.color }}>{p.initials}</div>
                <div className="post-body">
                  <div className="post-meta">
                    <span className="post-author">{p.author}</span>
                    <span className={`pill ${TAG_COLORS[p.tag] || 'pill-tag'}`}>{p.tag}</span>
                    <span className="post-time">{p.time}</span>
                  </div>
                  <div className="post-title">{p.title}</div>
                  <div className="post-excerpt">{p.excerpt}</div>
                  <div className="post-footer">
                    <span><ReplyIcon /> {p.replies} replies</span>
                    <span><ThumbIcon /> {p.helpful} helpful</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Sidebar */}
        <div>
          <div className="side-panel">
            <div className="side-panel-title">Topics</div>
            {TOPICS.map((t) => (
              <div key={t.label} className="side-panel-row">
                <span>{t.label}</span>
                <span className="side-panel-val">{t.count}</span>
              </div>
            ))}
          </div>
          <div className="side-panel">
            <div className="side-panel-title">Top Contributors</div>
            {LEADERS.map((l) => (
              <div key={l.rank} className="leader-row">
                <span className="leader-rank">{l.rank}</span>
                <div className="leader-av" style={{ background: l.color }}>{l.initials}</div>
                <span className="leader-name">{l.name}</span>
                <span className="leader-pts">{l.pts} pts</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommunityPage;

function ReplyIcon() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="13" height="13"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>;
}
function ThumbIcon() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="13" height="13"><path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3H14z"/><path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/></svg>;
}
